import { Styles } from "../../config"

const styles = {
	container: {},

	input: (value) => {
		let defaultBorder = "1px solid #46557880"
		if (value) defaultBorder = `1px solid ${Styles.Color.primary75}`

		return {
			color: Styles.Color.primary,
			borderRadius:'5px',

			"& .MuiOutlinedInput-notchedOutline": {
				border: defaultBorder
			},

			"&:hover .MuiOutlinedInput-notchedOutline": {
				border: `2px solid ${Styles.Color.primary75}`
			},

			"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
				border: `2px solid ${Styles.Color.primary75}`
			},

			"& input[type=number]": {
				"-moz-appearance": "textfield"
			},

			"& input[type=number]::-webkit-outer-spin-button": {
				"-webkit-appearance": "none",
				margin: 0
			},

			"& input[type=number]::-webkit-inner-spin-button": {
				"-webkit-appearance": "none",
				margin: 0
			},

			"& .MuiInputAdornment-root .MuiTypography-root": {
				color: Styles.Color.primary
			}
		}
	},

	label: {
		color: Styles.Color.primary,

		"&.Mui-focused": {
			color: Styles.Color.primary
		}
	},

	helperText: {
		color: Styles.Color.primary
	}
}

export default styles
